// extracted by mini-css-extract-plugin
export var border = "_22-8";
export var brand = "_22-t";
export var button = "_22-l";
export var center = "_22-a";
export var centered = "_22-6";
export var closeButton = "_22-c";
export var disabledWrapper = "_22-m";
export var error = "_22-p";
export var extraLarge = "_22-4";
export var extraSmall = "_22-1";
export var fill = "_22-i";
export var footer = "_22-h";
export var footerAction = "_22-j";
export var footerButtons = "_22-k";
export var header = "_22-7";
export var headerWithClose = "_22-d";
export var icon = "_22-o";
export var info = "_22-s";
export var inline = "_22-9";
export var large = "_22-3";
export var main = "_22-e";
export var modal = "_22-0";
export var nearFull = "_22-5";
export var neutral = "_22-u";
export var noPadding = "_22-g";
export var none = "_22-v";
export var scrollable = "_22-f";
export var small = "_22-2";
export var success = "_22-r";
export var tight = "_22-n";
export var titleIcon = "_22-b";
export var warn = "_22-q";